export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.hook('app:rendered', (ctx: any) => {
		const statusCode = ctx?.event?.node?.res?.statusCode
		if (statusCode >= 300) {
			ctx?.event?.node?.res?.setHeader('Cache-Control', 'no-store')
		}
	})
})
